import { call, put, takeLatest } from "redux-saga/effects";
import { CLIENT } from "../actions";
import generateAction from "../../utils/action-helpers";
import { searchClient } from "../../api/clients";
import redirectToLogin from "../../utils/redirect-to-login";

function* fetch({ payload }) {
  try {
    yield generateAction(CLIENT.LOADING);
    const { data } = yield call(searchClient, payload);
    yield put(generateAction(CLIENT.FETCH_SUCCESS, data));
    if (data.length === 1) {
      yield put(
        generateAction(CLIENT.SET_CLIENT, {
          value: data[0].tercero,
          label: data[0].name
        })
      );
    }
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(CLIENT.FETCH_ERROR));
  }
}

export default function* filesSagas() {
  yield takeLatest(CLIENT.FETCH, fetch);
}
